import { motion } from 'framer-motion';

// Animation variants for the header elements
export const headerVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

// Animation transition settings
export const headerTransition = {
  duration: 0.8,
};

// Function to generate random animation delay
export const getRandomDelay = () => Math.random() * 2;

// Function to generate random animation duration
export const getRandomDuration = () => 3 + Math.random() * 2;

// Function to generate random position for background elements
export const getRandomPosition = () => ({
  top: `${Math.random() * 100}%`,
  left: `${Math.random() * 100}%`,
});

// Function to create animated background elements
export const createAnimatedBackground = (count = 20) => {
  return Array(count).fill(null).map((_, i) => ({
    key: i,
    style: getRandomPosition(),
    animate: {
      y: [0, -20, 0],
      opacity: [0.5, 1, 0.5],
    },
    transition: {
      duration: getRandomDuration(),
      repeat: Infinity,
      delay: getRandomDelay(),
    },
  }));
};

// Function to create motion props for header elements
export const createMotionProps = (delay = 0) => ({
  initial: headerVariants.hidden,
  animate: headerVariants.visible,
  transition: { ...headerTransition, delay },
}); 